function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "payg-hi-dark_svg__a",
  x1: 49.5,
  y1: 46.61,
  x2: 142.5,
  y2: 139.61,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#f6f6f6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("symbol", {
  id: "payg-hi-dark_svg__b",
  "data-name": "PayG_ic_hi",
  viewBox: "0 0 192 192"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Mobile_ic_hi"
}, /*#__PURE__*/React.createElement("rect", {
  x: 56,
  y: 16,
  width: 80,
  height: 160,
  rx: 8,
  ry: 8,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128 174H64a8 8 0 01-8-8v2a8 8 0 008 8h64a8 8 0 008-8v-2a8 8 0 01-8 8z",
  opacity: 0.06
}), /*#__PURE__*/React.createElement("rect", {
  x: 60,
  y: 32,
  width: 72,
  height: 122,
  rx: 2,
  ry: 2,
  fill: "#f4f4f4"
}), /*#__PURE__*/React.createElement("rect", {
  x: 88,
  y: 24,
  width: 16,
  height: 2,
  rx: 0.71,
  ry: 0.71,
  opacity: 0.12
}), /*#__PURE__*/React.createElement("rect", {
  x: 82,
  y: 24,
  width: 2,
  height: 2,
  rx: 0.71,
  ry: 0.71,
  opacity: 0.12
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 164,
  r: 6,
  opacity: 0.12
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Bounding Box",
  fill: "none",
  d: "M0 0h192v192H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#payg-hi-dark_svg__a)",
  d: "M62 34.11h68v118H62z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#e60000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8,
  d: "M96 113.3V72.8M75.75 93.05h40.5"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "PayG_ic"
}, /*#__PURE__*/React.createElement("use", {
  "data-name": "PayG_ic_hi",
  width: 192,
  height: 192,
  xlinkHref: "#payg-hi-dark_svg__b"
}));

var SvgPaygHiDark = function SvgPaygHiDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2);
};

export default SvgPaygHiDark;